import { InfoRounded } from '@mui/icons-material';
import { Button, Grid, LinearProgress, Link, Paper, Step, StepContent, StepLabel, Stepper, Typography } from '@mui/material';
import { Box, useTheme } from '@mui/system';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import MainCard from 'ui-component/cards/MainCard';
import { UploadFormPdfModal } from './UploadFormPdfModal';
import DependencyService from 'views/DependenciesManagement/DependencyService';
import EmailServices from 'notifications/EmailServices';
import { logOut } from 'firebaseService/firebaseAuth';
import FirebaseStorageService from '../../../firebaseService/firebaseStorage';
import UserNotifyFirestoreService from 'views/NotificationManagement/services/NotificationServices';

export const UploadFormatFileValidating = () => {
  const { user } = useSelector((state) => state.user);
  const [userNotify, setUserNotify] = useState([]);
  const theme = useTheme();
  const [isLoading, setLoading] = useState(true);
  const [activeStep, setActiveStep] = useState(0);
  const [dependency, setDependency] = useState({});
  const [open, setOpen] = useState(false);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setLoading(true);
    let dep = JSON.parse(user?.reloadUserInfo?.customAttributes).dependence;
    DependencyService.getDependencies(dep)
      .then((data) => {
        if (data) setDependency(data);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const handleResources = async (data, setDataFunction) => {
      setDataFunction(data);
    };

    const unsubscribe = UserNotifyFirestoreService.subscribeToUserNotify((data) => handleResources(data, setUserNotify));

    return () => {
      unsubscribe();
    };
  }, []);

  const doUpdateDependencyHandler = async (filesUploaded) => {
    const form1 = filesUploaded.find((file) => file.name == 'form1');
    const form2 = filesUploaded.find((file) => file.name == 'form2');
    if (form1 && form2)
      setDependency({
        ...dependency,
        contact: {
          user: user.uid,
          displayName: user.displayName,
          phoneNumber: user.phoneNumber,
          email: user.email
        },
        format_1: form1.src,
        format_2: form2.src
      });
    const response = await DependencyService.updateDependency(dependency.id, {
      ...dependency,
      contact: {
        user: user.uid,
        displayName: user.displayName,
        phoneNumber: user.phoneNumber,
        email: user.email
      },
      format_1: form1.src,
      format_2: form2.src
    });

    if (response.success) {
      const emails = userNotify.map((user) => user.email).filter((email) => email && email.trim() !== '');
      if (emails.length > 0) {
        const notificationPromises = emails.map((email) =>
          EmailServices.validationFormNotification(email, user, {
            form1: form1.downloadURL,
            form2: form2.downloadURL
          })
        );

        await Promise.all(notificationPromises);
      }
    }
    return response;
  };

  const steps = [
    {
      label: 'Descarga los formularios del acuerdo.',
      description: `Descargue los formulario de "FORMATO 1 - NOMBRAMIENTO DEL REPRESENTANTE INSTITUCIONAL"
                    y FORMATO 2 - ACUERDO DE AFILIACIÓN INDIVIDUALIZADO.`
    },
    {
      label: 'Diligencia los formularios.',
      description: `Diligencia cuidadosamente los formularios descargados, estos deberán ser completados en su totalidad, 
                    sigue el siguien instructivo de ejemplo:`
    },
    {
      label: 'Subir los formularios.',
      description: `Completado los formularios debes ir al siguiente, y cargar ambos formularios al Portal, 
                    puedes seguir el siguiente instructivo para hacerlo correctamente.`
    },
    {
      label: 'Esperar la validación de los formularios.',
      description: `Completado el proceso de subida de los formularios, te informaremos en los proximos (2) días que acerca de tu proceso de registro
                    una ,vez el personal encargado de Google LLC realice la validación de los documentos 
                    entregados.`
    }
  ];

  const downloadURL = async (path) => {
    try {
      setLoading(true);
      const url = await FirebaseStorageService.downloadFile(path);
      window.open(url, '_blank');
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ marginTop: '20px' }}>
      <UploadFormPdfModal
        open={open}
        onClose={onClose}
        user={user}
        dependency={dependency}
        doUpdateDependencyHandler={doUpdateDependencyHandler}
      />
      <MainCard
        content={false}
        title="¡Ya casi esta listo! Completa el proceso de registro..."
        secondary={
          <Grid container justifyContent={'center'}>
            <Box>
              <InfoRounded sx={{ fontSize: '40px' }} color={theme.palette.grey[500]} />
            </Box>
          </Grid>
        }
      >
        {isLoading && <LinearProgress />}
        <Box style={{ textAlign: 'center', padding: '0.5rem 0px' }}>
          <Grid container justifyContent={'center'} padding={1}>
            <Box sx={{ maxWidth: 800 }}>
              <Typography variant="h3" gutterBottom>
                Hola {user.displayName}, bienvenido al Portal de Proyectos del Gobierno de El Salvador en convenio con Google LLC.
              </Typography>
            </Box>
          </Grid>

          <Grid container justifyContent={'center'} padding={2}>
            <Box sx={{ maxWidth: 700 }}>
              <Typography variant="body1" gutterBottom>
                Para completar el proceso de registro y puedas comenzar a subcribir los proyectos o requerimientos de la institución a la
                cual represntas deberas descargar y diligenciar debidamente los siguientes formularios, para completar el proceso, sigue los
                siguientes pasos:
              </Typography>
            </Box>
          </Grid>

          <Grid container justifyContent={'center'} mt={1} mb={5}>
            <Box sx={{ maxWidth: 400 }}>
              <Stepper activeStep={activeStep} orientation="vertical">
                {steps.map((step, index) => (
                  <Step key={step.label}>
                    <StepLabel optional={index === 4 ? <Typography variant="caption">¡En enhorabuena! </Typography> : null}>
                      {step.label}
                    </StepLabel>
                    <StepContent>
                      <Typography mt={1} mb={1}>
                        {step.description}
                      </Typography>
                      {index === 0 && (
                        <>
                          <Typography>
                            <Button
                              onClick={() => downloadURL('formatos/Form 1  - Modelo de nombramiento - Representante Institucional.docx')}
                            >
                              Formato 1.
                            </Button>{' '}
                            y{' '}
                            <Button
                              onClick={() =>
                                downloadURL('formatos/Form 2 - Modelo afiliación - Acuerdo de Afiliación Individualizado.docx')
                              }
                            >
                              Formato 2.
                            </Button>
                          </Typography>
                        </>
                      )}
                      {index === 1 && (
                        <>
                          <Typography>
                            <Button
                              onClick={() =>
                                downloadURL(
                                  'formatos/Gov. Rep. El Salvador_Amendment_GCP Customer Affiliate AgreementOrder Form [G. Template 08.03.23].pdf'
                                )
                              }
                            >
                              (Descargar)
                            </Button>
                          </Typography>
                        </>
                      )}
                      {index === 2 && (
                        <>
                          <Typography>
                            <Link sx={{ cursor: 'pointer' }} onClick={() => setOpen(true)}>
                              Cargar formatos.
                            </Link>
                          </Typography>
                        </>
                      )}
                      <Box sx={{ mb: 2, mt: 2 }}>
                        <div>
                          <Button
                            disabled={!(dependency.format_1 !== '' && dependency.format_2 !== '') && index === 2}
                            variant="contained"
                            onClick={handleNext}
                            sx={{ mt: 1, mr: 1 }}
                          >
                            {index === steps.length - 1 ? 'Finalizar' : 'Continuar'}
                          </Button>
                          <Button disabled={index === 0} onClick={handleBack} sx={{ mt: 1, mr: 1 }}>
                            Atras
                          </Button>
                        </div>
                      </Box>
                    </StepContent>
                  </Step>
                ))}
              </Stepper>
              {activeStep === steps.length && (
                <Paper square elevation={0} sx={{ p: 3 }}>
                  <Typography>
                    Ya has completado todos los pasos - revisa el correo al correo{' '}
                    <Typography variant="" color={'primary'}>
                      {user.email}
                    </Typography>{' '}
                    te estaremos informando acerca proceso.
                  </Typography>
                  <Button onClick={handleReset} sx={{ mt: 1, mr: 1 }}>
                    {' '}
                    Reiniciar{' '}
                  </Button>
                  <Button onClick={logOut} sx={{ mt: 1, mr: 1 }}>
                    {' '}
                    Salir{' '}
                  </Button>
                </Paper>
              )}
            </Box>
          </Grid>
        </Box>
      </MainCard>
    </div>
  );
};
